// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ChromeFilledSvg from "@ant-design/icons-svg/es/asn/ChromeFilled";
import AntdIcon from '../components/AntdIcon';

var ChromeFilled = function ChromeFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ChromeFilledSvg
  }));
};

ChromeFilled.displayName = 'ChromeFilled';
export default React.forwardRef(ChromeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ChromeFilled.js
// module id = 761
// module chunks = 0